import React from "react";
import { Box, Divider } from "@mui/material";

const VerticalList = ({ items }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column", // Stack items vertically
        width: "100%", // Ensure full width for the divider
        fontSize: "1rem",
      }}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "0.375rem 0", // Padding around the item
            }}
          >
            {item}
          </Box>

          {/* Render a Divider between items except after the last one */}
          {index !== items.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default VerticalList;
